<!-- eslint-disable vue/no-v-html -->
<template>
  <div v-if="quoteData">
    <div v-if="quoteData.code === 500 || quoteData.length === 0" class="cms-error">
      <span>{{ $t('not_cms') }}</span>
    </div>
    <div v-else class="quote-page has-side-bars">
      <span class="quote-title" v-html="quoteData[0].title" />
      <div v-cms="quoteData[0].htmldefinition" class="quote-def" />
    </div>
  </div>
  <div v-else>
    <Loader :text="$t('loading')" />
  </div>
</template>

<script>
import { vCmsHtml as cms, getCMSWebpages } from '@/services/graphql'
import Loader from '../components/Loader.vue'

export default {
  components: { Loader },
  directives: { cms },
  props: {},
  asyncComputed: {
    quoteData() {
      return getCMSWebpages(this.$store.state.i18n.lang, 'quote')
    },
  },
}
</script>

<style lang="stylus" scoped>
.quote-page
  display: flex
  flex-direction: column
  margin-top: vw(30px)
  margin-bottom: vw(20px)
  min-height: "calc(100vh - %s - %s - %s - %s)" % ($header-height $subheader-height $footer-height vw(50px))
  gap: vw(6px)

  .quote-title
    m-font-size(30, 34)
    color: black
    font-weight: 600

  .quote-def
    m-font-size(16, 24)
    color: $grey-dark

    >>> a
      color: $corporate_color !important
      text-decoration: none

      &:hover
        color: $corporate_color !important
        text-decoration: underline
        cursor: pointer

    >>> li
      margin-left: vw(20px)
      padding: 0
      list-style-type: disc

.cms-error
  display: flex
  justify-content: center
  align-items: center
  min-height: "calc(100vh - %s - %s - %s - %s)" % ($header-height $subheader-height $footer-height vw(50px))

  span
    m-font-size(20, 26)
    color: black
    font-weight: 400
</style>
